// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"aee35311","14":"6107399e","348":"854782e2","453":"8701dc61","483":"a0852863","711":"b4d5acaa","937":"8de964d2"}[chunkId] + ".chunk.js";
};